<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Cargo" resource="cargos" primaryKey="idcargo" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import CargoService from "@/services/cargo.service";
import { cargo } from "@/models/cargo";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: cargo,
      service: CargoService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        CargoService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
